import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 },
};

const FeaturesPage = () => {
  const detailedFeatures = [
    {
      id: "gallery",
      title: "ألبوم الصور الحي",
      icon: "📸",
      description: "اجمع كل صور مناسبتك في مكان واحد. الضيوف بيمسحوا الـ QR وبيرفعوا الصور اللي بيصوروها في لحظتها، وكل الصور بتظهر فوراً في الألبوم المباشر.",
      details: [
        "رفع صور بجودة عالية.",
        "دعم لعدد غير محدود من الضيوف.",
        "خاصية الـ Double Tap للإعجاب بالصور.",
        "عرض الصور فوراً بدون انتظار."
      ]
    },
    {
      id: "voice",
      title: "دفتر الضيوف الصوتي",
      icon: "🎙️",
      description: "بديل عصري لدفتر التهاني التقليدي. ضيوفك يقدروا يسجلوا رسايل صوتية بتباركلك وبتحكي ذكرياتهم معاك، وتفضل الذكرى بصوتهم للأبد.",
      details: [
        "تسجيل صوتي سهل من الموبايل.",
        "بدون الحاجة لتحميل تطبيقات.",
        "احتفاظ بالرسايل في لوحة تحكمك.",
        "إمكانية الاستماع والتحميل في أي وقت."
      ]
    },
    {
      id: "slideshow",
      title: "العرض الحي (Slideshow)",
      icon: "📺",
      description: "خلي الفرح كله يتفرج على الصور اللي بتترفع في لحظتها. تقدر تعرض الـ Slideshow على شاشات القاعة، وكل صورة جديدة بتنزل بتظهر تلقائياً.",
      details: [
        "تحديث تلقائي للصور الجديدة.",
        "انتقالات سلسة وجذابة.",
        "تحكم كامل في الصور المعروضة.",
        "مناسب لشاشات العرض الكبيرة."
      ]
    },
    {
      id: "qr",
      title: "سهولة المشاركة (QR Code)",
      icon: "📲",
      description: "انسى وجع الدماغ بتاع 'ابعثلي الصور'. بمجرد ما تطبع الـ QR وتوزعه، الضيوف بيدخلوا ويرفعوا الصور في ثواني.",
      details: [
        "توليد QR Code خاص بكل مناسبة.",
        "سهولة النسخ والمشاركة عبر واتساب.",
        "لا يحتاج الضيف لإنشاء حساب.",
        "يعمل على جميع أنواع الموبايلات."
      ]
    },
    {
      id: "download",
      title: "تحميل الكل (ZIP)",
      icon: "📦",
      description: "بعد ما الفرح يخلص، مش محتاج تحمل صورة صورة. تقدر تحمل كل الميديا اللي اترفع في ملف واحد مضغوط وبضغطة زرار واحدة.",
      details: [
        "تحميل كل الصور والفيديوهات دفعة واحدة.",
        "ملف ZIP منظم بأسماء الضيوف.",
        "جودة الصور الأصلية بدون ضغط.",
        "رابط تحميل سريع وآمن."
      ]
    }
  ];

  return (
    <div className="features-page pb-5 bg-background" dir="rtl">
      <section className="bg-primary text-white py-5 mb-5 text-center shadow-lg" style={{ borderRadius: "0 0 40px 40px" }}>
        <div className="container py-4">
          <motion.h1 className="display-4 fw-black" style={{ fontFamily: 'var(--font-headline)' }} {...fadeUp}>مميزات يومك بالتفصيل</motion.h1>
          <motion.p className="fs-4 arabic-leading mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
            كل اللي محتاجه عشان تخلي مناسبتك ذكرى ما تتنسيش
          </motion.p>
        </div>
      </section>

      <div className="container">
        {detailedFeatures.map((feature, index) => (
          <motion.div
            key={feature.id}
            id={feature.id}
            className={`row align-items-center mb-5 g-4 ${index % 2 !== 0 ? 'flex-row-reverse' : ''}`}
            initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="col-md-6 text-center">
              <div className="display-1 bg-surface-variant rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm border border-primary-dim" style={{ width: "clamp(120px, 40vw, 180px)", height: "clamp(120px, 40vw, 180px)" }}>
                {feature.icon}
              </div>
            </div>
            <div className="col-md-6">
              <h2 className="fw-black text-primary mb-3" style={{ fontFamily: 'var(--font-headline)' }}>{feature.title}</h2>
              <p className="fs-5 text-on-surface-variant mb-4 arabic-leading">{feature.description}</p>
              <ul className="list-unstyled">
                {feature.details.map((detail, i) => (
                  <li key={i} className="mb-2 fs-6 fw-medium text-on-surface">
                    <span className="text-primary me-2">✔</span> {detail}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}

        <div className="text-center mt-5 py-5 bg-surface-variant rounded-celebration shadow-sm border border-primary-dim border-top border-primary border-5">
           <h3 className="fw-black mb-4 text-primary" style={{ fontFamily: 'var(--font-headline)' }}>جاهز تبدأ مناسبتك؟</h3>
           <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to="/register" className="btn btn-primary btn-lg px-5 py-3 rounded-pill shadow-lg fw-bold">اشتراك جديد 🚀</Link>
              <Link to="/" className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill fw-bold bg-white">الرجوع للرئيسية</Link>
           </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;
